/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class CpcGoodsTax {
  public taxCode: string = undefined;
  public taxBase: number = undefined;
  public taxAmount: number = undefined;
  public taxUnit: string = undefined;
  public taxRate: number = undefined;
  public taxSequence: number = undefined;
  public taxSequenceSpecified: boolean;
}
